<template>
    <form
        class="space-y-6"
        @submit.prevent="submit"
    >
        <h3 class="subtitle">
            Créer journée pour {{ staff.first_name }} {{ staff.last_name }}
        </h3>

        <div class="pb-6 border-b">
            <UiSelect
                name="staff_schedule_uuid"
                :options="staffSchedulesOptions"
                label="Pré remplir selon un horaire type"
                @update:model-value="setScheduleFromStaffSchedule"
            />
        </div>

        <UiSelect
            v-model="formData.type"
            label="Type"
            name="type"
            :options="typeOptions"
        />

        <UiSelect
            v-model="formData.extra_type"
            label="Sous Type"
            name="type"
            :options="extraTypeOptions"
        />

        <div class="grid grid-cols-2 gap-6">
            <UiInput
                v-model="formData.should_start_at"
                label="Arrive à"
                type="time"
                name="should_start_at"
                required
                placeholder="Arrive à"
            />
            <UiInput
                v-model="formData.should_left_at"
                type="time"
                name="should_left_at"
                label="Part à"
                required
                placeholder="Part à"
            />
        </div>
        <div
            v-if="formData.type <= 2"
            class="grid grid-cols-2 gap-6"
        >
            <UiInput
                v-model="formData.pause_start_at"
                label="Pause démarre à"
                :errors="errors"
                name="pause_start_at"
                type="time"
            />
            <UiInput
                v-model="formData.pause_stop_at"
                label="Pause fini à"
                :errors="errors"
                name="pause_stop_at"
                type="time"
            />
        </div>

        <UiSelect
            v-model="formData.classroom_uuid"
            name="classroom_uuid"
            :errors="errors"
            label="Attribuer à une section"
            :options="classroomOptions"
        />

        <UiTextarea
            v-model="formData.note"
            label="Remarques"
            name="note"
            placeholder="Écrivez ici"
        />

        <div class="flex justify-between">
            <button
                type="submit"
                class="btn btn-primary"
                :class="{ loading: isLoading }"
            >
                Sauvegarder
            </button>
        </div>
    </form>
</template>

<script>
import dayjs from 'dayjs'
import { extraTypes, types } from 'abcreche-constants/src/const/staffs/attendances/types'
import { dateRangeMixin, loadingMixin } from 'abcreche-ui'
import classroomOptions from '~~/mixins/classrooms/classroomOptions'
import StaffSchedulesRepository from '~~/repositories/Creche/StaffSchedulesRepository.js'
import StaffAttendanceRepository from '~~/repositories/Creche/StaffAttendanceRepository.js'

export default {
    mixins: [loadingMixin, dateRangeMixin, classroomOptions],

    props: {
        staff: {
            type: Object,
            required: true
        },
        date: {
            type: String,
            required: true
        }
    },
    emits: ['updated'],
    data () {
        return {
            formData: {
                type: 2,
                extra_type: null,
                note: '',
                should_start_at: '08:00',
                should_left_at: '18:00',
                pause_start_at: '12:00',
                pause_stop_at: '13:00',
                classroom_uuid: null
            },
            staffSchedules: []
        }
    },

    computed: {
        typeOptions: types,
        extraTypeOptions: extraTypes,
        quarterHours () {
            return this.generateDateRange(
                dayjs().hour(6).minute(0),
                dayjs().hour(19).minute(59),
                15,
                'minutes',
                'HH:mm'
            )
        },
        staffSchedulesOptions () {
            return this.staffSchedules.map((schedule) => {
                if (schedule.pause_start_at && schedule.pause_stop_at) {
                    return {
                        value: schedule.uuid,
                        label: schedule.name + ' (' + schedule.from.slice(0, -3) + ' - ' + schedule.to.slice(0, -3) + ')' + ' (pause : ' + schedule.pause_start_at.slice(0, -3) + ' - ' + schedule.pause_stop_at.slice(0, -3) + ')'
                    }
                }
                return {
                    value: schedule.uuid,
                    label: schedule.name + ' (' + schedule.from.slice(0, -3) + ' - ' + schedule.to.slice(0, -3) + ')'
                }
            })
        }
    },

    created () {
        this.fetchClassrooms()
            .catch(error => this.pageError(error))
        this.getStaffSchedules()
    },

    methods: {
        getStaffSchedules () {
            StaffSchedulesRepository.index()
                .then((response) => {
                    this.staffSchedules = response.data
                })
                .catch(error => this.pageError(error))
        },
        setScheduleFromStaffSchedule (value) {
            const schedule = this.staffSchedules.find(s => s.uuid === value)

            this.formData.should_start_at = schedule.from.slice(0, -3)
            this.formData.should_left_at = schedule.to.slice(0, -3)
            this.formData.pause_start_at = schedule.pause_start_at ? schedule.pause_start_at.slice(0, -3) : null
            this.formData.pause_stop_at = schedule.pause_stop_at ? schedule.pause_stop_at.slice(0, -3) : null
        },

        submit () {
            this.load()

            const data = { ...this.formData }
            data.should_start_at = this.date + ' ' + this.formData.should_start_at
            data.should_left_at = this.date + ' ' + this.formData.should_left_at
            data.date = this.date

            StaffAttendanceRepository.store(this.staff.uuid, data)
                .then(() => {
                    this.$emit('updated')
                    this.done('La journée a été correctement créee !')
                })
                .catch(error => this.doneWithErrors(error.response.data))
        },

        changeHours (h) {
            this.formData.should_start_at = h[0]
            this.formData.should_left_at = h[1]
        }
    }
}
</script>
